module.exports = __webpack_public_path__ + "static/img/pro4_tab2.bffdfc0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/advertisement/introduceFour/pro4_tab2.jpg
// module id = LQ2a
// module chunks = 171